import React, { useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import API_BASE_URL from '../../config';
import './DNSLookup.css';

const DNSLookup = () => {
  const { t } = useTranslation();
  const [domain, setDomain] = useState('');
  const [records, setRecords] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleLookup = async () => {
    let cleanDomain = domain
      .trim()
      .replace(/^(?:https?:\/\/)?(?:www\.)?/i, "")
      .split('/')[0];

    if (!cleanDomain) {
      alert(t('enterValidDomain') || "Please enter a valid domain");
      return;
    }

    setLoading(true);
    setRecords(null);

    try {
      // ✅ BASE URL USED HERE
      const res = await axios.post(
        `${API_BASE_URL}/diagnostic-tools/dnslookup`,
        { domain: cleanDomain }
      );

      if (res.data && res.data.dns_records) {
        setRecords(res.data.dns_records);
      } else {
        setRecords({ error: "No records found or invalid response" });
      }

    } catch (error) {
      console.error("DNS Lookup Error:", error);

      const errorMsg =
        error.response?.data?.error ||
        t('fetchFailed') ||
        "Failed to fetch data";

      setRecords({ error: errorMsg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dnslookup-container">
      <h3 className="dnslookup-title">
        🌐 {t('dnsLookup') || "DNS Lookup"}
      </h3>

      <div className="dnslookup-input-group">
        <input
          className="dnslookup-input"
          placeholder={t('domainPlaceholder') || "example.com"}
          value={domain}
          onChange={e => setDomain(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleLookup()}
        />

        <button
          className="dnslookup-button"
          onClick={handleLookup}
          disabled={loading}
        >
          {loading
            ? (t('loading') || "Loading...")
            : (t('lookup') || "Lookup")}
        </button>
      </div>

      {records && (
        <div className="dnslookup-results">

          {records.error ? (
            <p className="dnslookup-error">{records.error}</p>
          ) : (
            Object.entries(records).map(([type, values]) => (
              <div key={type} className="dnslookup-record-type">

                <h4>
                  {type} {t('records', { defaultValue: 'Records' })}
                </h4>

                {type === 'A' && Array.isArray(values) ? (
                  <ul>
                    {values.map((item, idx) => (
                      <li key={idx} className="dnslookup-ip-item">
                        <div><strong>IP Info:</strong> {item.ip}</div>
                        <div><strong>ISP Info:</strong> {item.org}</div>
                        <div><strong>Location:</strong> {item.country}</div>
                      </li>
                    ))}
                  </ul>
                ) : Array.isArray(values) && values.length > 0 ? (
                  <ul>
                    {values.map((val, idx) => (
                      <li key={idx} className="dnslookup-item-single">
                        {val}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="dnslookup-no-record">
                    {t('noRecord') || "No records found"}
                  </p>
                )}

              </div>
            ))
          )}

        </div>
      )}
    </div>
  );
};

export default DNSLookup;